module.exports = __webpack_public_path__ + "static/media/landing_page_pallet1.52094f79.png";